import { createListenerMiddleware, ThunkDispatch, UnknownAction } from '@reduxjs/toolkit'

import { RootState } from '@/store'
import { storeActions, ThunkExtra } from '@/store/actions'
import { checkAuth } from '@/store/auth/thunks'

const instance = createListenerMiddleware<
  RootState,
  ThunkDispatch<RootState, ThunkExtra, UnknownAction>
>()

instance.startListening({
  actionCreator: storeActions.login.fulfilled,
  effect: (_, listenerApi) => {
    listenerApi.cancelActiveListeners()
    listenerApi.dispatch(checkAuth() as unknown as UnknownAction)
  },
})

export const authMiddleware = instance.middleware
